<div
    class="flex min-h-full w-full flex-col justify-between"
    [style.backgroundImage]="backgroundImageStyle()"
    [style.backgroundSize]="backgroundImageStyle() ? 'cover' : null"
    [style.backgroundPosition]="backgroundImageStyle() ? 'center top' : null"
    [style.backgroundAttachment]="backgroundImageStyle() ? 'fixed' : null"
    [style.backgroundColor]="backgroundColorStyle()">
    <div>
        <app-global-banner></app-global-banner>
        @if (!partnerTheme()) {
            <app-global-header></app-global-header>
        }
        <router-outlet></router-outlet>
        <app-toast></app-toast>
    </div>
    <app-restaurant-logo-footer></app-restaurant-logo-footer>
</div>
